import api from './serviceApi'; // Import the axios instance

const userApi = {
    /**
     * Fetch a specific user by code.
     * @param {string} code - The unique code of the user.
     * @param {Object} params - Query parameters like `id` and `include`.
     * @returns {Promise<Object>} - The user data.
     */
    getUserByCode: async (code, params = {}) => {
        try {
            const response = await api.get(`/User/${code}`, { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching user by code:', error);
            throw error;
        }
    },

    /**
    * inativate a person by their code.
    * @param {string} personCode - The person code to inativate.
    * @returns {Promise<Object>} - The result of the deletion.
    */
    setInactive: async (personCode) => {
        try {
            const response = await api.put('/user/setInactive/' + personCode);
            return response.data;
        } catch (error) {
            console.error('Error inativating person:', error);
            throw error;
        }
    },

    /**
    * active a person by their code.
    * @param {string} personCode - The person code to active.
    * @returns {Promise<Object>} - The result of the deletion.
    */
    setActive: async (personCode) => {
        try {
            const response = await api.put('/user/setActive/' + personCode);
            return response.data;
        } catch (error) {
            console.error('Error inativating person:', error);
            throw error;
        }
    },

    /**
     * Export user data with specified filters.
     * @param {Object} params - Query parameters like `quantityMax`, `isActive`, `term`, etc.
     * @returns {Promise<Object>} - The exported user data.
     */
    exportUsers: async (params) => {
        try {
            const response = await api.get('/User/export', { params });
            return response.data;
        } catch (error) {
            console.error('Error exporting user data:', error);
            throw error;
        }
    },

    setPassword: async (token, payload) => {
        const response = await api.post(`/User/setPassword/${token}`,payload);
        return response.data;
    },

    /**
     * Fetch paginated user data.
     * @param {Object} params - Query parameters like `page`, `quantity`, `isActive`, etc.
     * @returns {Promise<Object>} - The paginated user data.
     */
    getUsersPaginated: async (params) => {
        try {
            const response = await api.get('/User/pagged', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching paginated user data:', error);
            throw error;
        }
    },

    /**
     * Fetch all users with filters.
     * @param {Object} params - Query parameters like `include`.
     * @returns {Promise<Object>} - The user data.
     */
    getUsers: async (params = {}) => {
        try {
            const response = await api.get('/User', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching users:', error);
            throw error;
        }
    },

    /**
     * Create a new user.
     * @param {Object} data - The user payload.
     * @returns {Promise<Object>} - The created user data.
     */
    createUser: async (data) => {
        try {
            const response = await api.post('/User', data);
            return response.data;
        } catch (error) {
            console.error('Error creating user:', error);
            throw error;
        }
    },

    /**
     * Update an existing user.
     * @param {Object} data - The updated user payload.
     * @returns {Promise<Object>} - The updated user data.
     */
    updateUser: async (data) => {
        try {
            const response = await api.put('/User', data);
            return response.data;
        } catch (error) {
            console.error('Error updating user:', error);
            throw error;
        }
    },

    /**
     * Delete a user.
     * @param {Object} data - The user payload to delete.
     * @returns {Promise<Object>} - The deleted user response.
     */
    deleteUser: async (data) => {
        try {
            const response = await api.delete('/User', { data });
            return response.data;
        } catch (error) {
            console.error('Error deleting user:', error);
            throw error;
        }
    },

    /**
     * Update password.
     * @param {Object} data - The updated user payload.
     * @returns {Promise<Object>} - The updated user data.
     */
    updatePassword: async (data) => {
        try {
            const response = await api.put('/User/update-password', data);
            return response.data;
        } catch (error) {
            console.error('Error updating user:', error);
            throw error;
        }
    },
};

export default userApi;
